/*
 * Round 14 (note N1): what a failed /uiapi/slots/{slot}/stats | targets/not-found | .../restore
 * call means, read from the server's own answer.
 *
 * The round-14 server answers its errors as { error: <code>, message: <sentence> }
 * (UiApiSlotStatsController.problem). The codes that matter here, all on a 404:
 *
 *   not_enabled        the route exists, the server's round-14 part is switched OFF
 *   slot_not_found     no slot of that name on the logged-in account
 *   target_not_listed  the restored target is not on the list any more (restored in another tab)
 *
 * A 404/405 WITHOUT one of those codes is a server that has no such route at all (round 13 or
 * older; Spring's own 404 body carries error: "Not Found", which is not a code of ours).
 *
 * The message shown is the server's `message` (the axios interceptor in lib/api.js also copies it
 * into `detail`), never the bare code.
 */

export const R14_ERROR_CODES = ['not_enabled', 'slot_not_found', 'target_not_listed'];

/**
 * @returns {{ kind: 'routeMissing'|'notEnabled'|'slotNotFound'|'targetNotListed'|'other',
 *             status: number|null, code: string|null, message: string|null }}
 */
export function classifyR14Error(err) {
  const res = err && err.response;
  const status = res && typeof res.status === 'number' ? res.status : null;
  const data = res && res.data && typeof res.data === 'object' ? res.data : null;
  const code = data && typeof data.error === 'string' && R14_ERROR_CODES.includes(data.error) ? data.error : null;
  const text = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);
  const message = data ? (text(data.message) || text(data.detail)) : null;

  let kind = 'other';
  if (code === 'not_enabled') kind = 'notEnabled';
  else if (code === 'slot_not_found') kind = 'slotNotFound';
  else if (code === 'target_not_listed') kind = 'targetNotListed';
  else if (status === 404 || status === 405) kind = 'routeMissing';
  return { kind, status, code, message };
}

/** The sentence to show for a failed call: the server's message, else its code, else the status. */
export function r14ErrorText(err, fallback) {
  const c = classifyR14Error(err);
  const data = err && err.response && err.response.data;
  const rawCode = data && typeof data === 'object' && typeof data.error === 'string' ? data.error : null;
  return c.message || rawCode || (c.status ? `${fallback} (HTTP ${c.status})` : fallback);
}
